import { useMemo } from 'react'

import { Colors } from '~/styles'

import Styled from './vessel-traffic-legend.styled'

const VesselTrafficLegend = () => {
  // Define the legend items with their respective colors and labels
  // Using useMemo to memoize the legend items to avoid unnecessary re-renders
  const listTrafficLegend = useMemo(() => [
    { color: Colors.lightOlive, label: 'Vessel Berthing' },
    { color: Colors.lemonYellow, label: 'Upcoming Vessel' },
  ], [])

  return (
    <Styled.LegendContainer id='vessel-traffic-information-legend'>
      <Styled.ListLegendGroup>
        {listTrafficLegend.map((item) => (
          <Styled.ListLegendItem key={item.label}>
            <Styled.LegendColorBox color={item.color} />
            {item.label}
          </Styled.ListLegendItem>
        ))}
      </Styled.ListLegendGroup>
    </Styled.LegendContainer>
  )
}

VesselTrafficLegend.propTypes = {}

export default VesselTrafficLegend